package com.eladfinish.bible.contest.screens.verseWidget

import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt
import com.eladfinish.bible.contest.features.verseWidget.VerseWidgetConfig
import com.eladfinish.bible.contest.features.verseWidget.VerseWidgetEntryPoint
import com.eladfinish.bible.contest.features.verseWidget.VerseWidgetOrder
import com.eladfinish.bible.contest.features.verseWidget.VerseWidgetSource
import com.eladfinish.bible.contest.features.verseWidget.WidgetVerse

data class VerseWidgetState(
    val config: VerseWidgetConfig,
    /** The verse the widget shows right now with [config]; `null` when there is none (an empty mikud). */
    val preview: WidgetVerse?,
    /** How many widgets are on the home screens; `null` when the platform cannot tell. */
    val installedCount: Int?,
    val canRequestPin: Boolean,
    val isInstructionsVisible: Boolean = false,
    /** The "what is a widget?" picture is open. */
    val isExampleVisible: Boolean = false,
    /** What the picture is loaded from; read when it is opened, so a new Remote Config value counts at once. */
    val exampleImageUrl: String = "",
) : StateKt {
    val isWidgetInstalled: Boolean
        get() = (installedCount ?: 0) > 0
}

sealed interface VerseWidgetAction : ActionKt {
    /** The screen was opened (once per visit): only reported. The first [Resumed] fills the preview. */
    data class Opened(val entryPoint: VerseWidgetEntryPoint) : VerseWidgetAction

    /** The screen came to the front: the widget may have been added or removed meanwhile. */
    data object Resumed : VerseWidgetAction

    data class SourceSelected(val source: VerseWidgetSource) : VerseWidgetAction
    data class BookSelected(val bookNumber: Int) : VerseWidgetAction
    data class OrderSelected(val order: VerseWidgetOrder) : VerseWidgetAction
    data class IntervalSelected(val minutes: Int) : VerseWidgetAction
    data class NikudChanged(val showNikud: Boolean) : VerseWidgetAction
    data class TeamimChanged(val showTeamim: Boolean) : VerseWidgetAction

    data object AddClicked : VerseWidgetAction
    data object InstructionsDismissed : VerseWidgetAction
    data object ExampleClicked : VerseWidgetAction
    data object ExampleDismissed : VerseWidgetAction
}

/** The screen has nothing to tell the UI that its state does not already say. */
sealed interface VerseWidgetEffect : EffectKt
